import axios from "axios";

const BASE = process.env.REACT_APP_BACKEND_URL;
export const API = `${BASE}/api`;

const CLE = "sillage_token";
const CLE_ADMIN = "servae_admin_token";
const CLE_APERCU = "servae_apercu";

export const jeton = {
  lire: () => localStorage.getItem(CLE),
  ecrire: (t) => localStorage.setItem(CLE, t),
  effacer: () => localStorage.removeItem(CLE),
};

/** L'admin regarde l'application avec les yeux d'un pro, sans perdre sa propre session. */
export const apercu = {
  actif: () => localStorage.getItem(CLE_APERCU),
  entrer: (tokenPro, nomPro) => {
    localStorage.setItem(CLE_ADMIN, localStorage.getItem(CLE) || "");
    localStorage.setItem(CLE_APERCU, nomPro || "un professionnel");
    jeton.ecrire(tokenPro);
  },
  sortir: () => {
    const admin = localStorage.getItem(CLE_ADMIN);
    localStorage.removeItem(CLE_APERCU);
    localStorage.removeItem(CLE_ADMIN);
    if (admin) jeton.ecrire(admin);
    else jeton.effacer();
  },
};

export const api = axios.create({ baseURL: API, timeout: 25000 });

api.interceptors.request.use((config) => {
  const t = jeton.lire();
  if (t) config.headers.Authorization = `Bearer ${t}`;
  return config;
});

let surDeconnexion = null;
export const brancherDeconnexion = (fn) => {
  surDeconnexion = fn;
};

api.interceptors.response.use(
  (r) => r,
  (err) => {
    const publique = (err.config?.url || "").includes("/public/");
    if (err.response?.status === 401 && !publique) {
      jeton.effacer();
      if (surDeconnexion) surDeconnexion();
    }
    return Promise.reject(err);
  }
);

/** Message d'erreur lisible par un humain, jamais une trace technique. */
export function messageErreur(err, repli = "Une erreur est survenue.") {
  const d = err?.response?.data?.detail;
  if (typeof d === "string") return d;
  if (Array.isArray(d) && d.length) {
    const premier = d[0];
    if (premier?.msg) return premier.msg.replace("Value error, ", "");
  }
  if (err?.code === "ECONNABORTED") return "La connexion est trop lente. Réessayez.";
  if (!err?.response) return "Pas de connexion. Vérifiez votre réseau.";
  return repli;
}
